import { Injectable } from '@angular/core';
import { IBulkProfileResultModel } from '../entities-api/IBulkProfileResultModel';
import { IBulkProfileModel } from '../entities-api/IBulkProfileModel';
import { IGlobalEmployeeDetailGridDataModel } from '../entities-api/IGlobalEmployeeDetailGridDataModel';
import { IGlobalEmployeeDictionariesModel } from '../entities-api/IGlobalEmployeeDictionariesModel';
import { IGlobalEmployeeInfoModel } from '../entities-api/IGlobalEmployeeInfoModel';
import { IGlobalEmployeeOverrideModel } from '../entities-api/IGlobalEmployeeOverrideModel';
import { IUserFetchCriteriaModel } from '../entities-api/IUserFetchCriteriaModel';
import { IUserProfileDataModel } from '../entities-api/IUserProfileDataModel';
import { IRequest } from '../entities/request.interface';
import { BaseRepository } from './base.repository';
import { IAppcodeModel } from '../entities-api/IAppcodeModel';
import { IMfcodemodel } from '../entities-api/IMfcodemodel';
import { IContainerMappingFetchCriteriaModel } from '../entities-api/IContainerMappingFetchCriteriaModel';
import { IContainerMappingDetailGridDataModel } from '../entities-api/IContainerMappingDetailGridDataModel';
import { IGeocodemodel } from '../entities-api/IGeocodemodel';
import { IMfModel } from '../entities-api/IMfModel';
import { IBaseMappingFetchCriteriaModel } from '../entities-api/IBaseMappingFetchCriteriaModel';
import { IBaseMappingDetailGridDataModel } from '../entities-api/IBaseMappingDetailGridDataModel';
import { IOnboardedAppGridModel } from '../entities-api/IOnboardedAppGridModel';
import { IOnBoardedAppFetchCriteriaModel } from '../entities-api/IOnBoardedAppFetchCriteriaModel';

@Injectable()
export class ContainerMappingRepository extends BaseRepository {
  getCurrentUserAsync(): Promise<IGlobalEmployeeInfoModel> {
    return this.get<IGlobalEmployeeInfoModel>('/api/ContainerMapping/Current');
  }
  getEnv(): Promise<string> {
    return this.get("api/ContainerMapping/GetEnv");
  }
  getBasemappings(filter: IBaseMappingFetchCriteriaModel): Promise<IBaseMappingDetailGridDataModel> {
    let request: IRequest = {
      Url: "api/ContainerMapping/BaseMappings",
      Body: filter
    };

    return this.post<IBaseMappingDetailGridDataModel>(request);
  }
  getContainermappings(filter: IContainerMappingFetchCriteriaModel): Promise<IContainerMappingDetailGridDataModel> {
    let request: IRequest = {
      Url: "api/ContainerMapping/GetContainermappings",
      Body: filter
    };

    return this.post<IContainerMappingDetailGridDataModel>(request);
  }
  getappcodes(): Promise<IAppcodeModel> {
    return this.get("api/ContainerMapping/GetAppcodes");
  }

  getMfCodes(mfmodel: IMfModel): Promise<IMfcodemodel> {
    var request: IRequest = {
      Url: "api/ContainerMapping/GetMfcodes",
      Body: mfmodel
    };

    return this.post(request);

  }
  getMfCodesBase(mfmodel: IMfModel): Promise<IMfcodemodel> {
    var request: IRequest = {
      Url: "api/ContainerMapping/BaseMappingMFCode",
      Body: mfmodel
    };

    return this.post(request);

  }
  getgeocodes(): Promise<IGeocodemodel> {
    return this.get("api/ContainerMapping/GetGeocodes");
  }
  getgeocodesBase(): Promise<IGeocodemodel> {
    return this.get("api/ContainerMapping/BaseMappingGEOCode");
  }
  getAllContainermappings(filter: IContainerMappingFetchCriteriaModel): Promise<IContainerMappingDetailGridDataModel> {
    let request: IRequest = {
      Url: "api/ContainerMapping/GetAllContainermappings",
      Body: filter
    };

    return this.post<IContainerMappingDetailGridDataModel>(request);
  }
  getOnboardedApps(filter: IOnBoardedAppFetchCriteriaModel): Promise<IOnboardedAppGridModel> {
    let request: IRequest = {
      Url: "api/ContainerMapping/OnBoardedApps",
      Body: filter
    };
    return this.post<IOnboardedAppGridModel>(request);
  }
}
